const KEY = "gxr.device";

/** A random per-install id. Never leaves the device unhashed (the API salts and hashes it). */
export function getDeviceId(storage: Pick<Storage, "getItem" | "setItem"> = localStorage): string {
  const existing = storage.getItem(KEY);
  if (existing) return existing;
  const id = crypto.randomUUID();
  storage.setItem(KEY, id);
  return id;
}
